import jquery from 'jquery';
import EFOcats_event_core from './efocats_event_core.js';
/**
 * TABキーイベント
 */
export default class EFOcats_event_tab extends EFOcats_event_core {
  /**
   * イベント本体をセット
   */
  event() {
    this.$('.box-label').on('keydown', evt => {
      const element = evt.currentTarget;

      if (evt.which === 32) {
        jquery(element)
          .children('input')
          .each((index, elem) => {
            if (jquery(elem).attr('type') === 'radio') {
              jquery(elem).parents('.inner').find('input').prop('checked', false);
              jquery(elem).parents('.inner').find('.active').removeClass('active');

              jquery(elem).prop('checked', true);
              jquery(elem).parents('.box-label').addClass('active');
            } else {
              jquery(elem).prop('checked', !jquery(elem).prop('checked'));

              if (jquery(elem).is(':checked')) {
                jquery(elem).parents('.box-label').addClass('active');
              } else {
                jquery(elem).parents('.box-label').removeClass('active');
              }
            }

            // エラーチェック
            efocats.validations.check_error(jquery(elem));
          });
      }
    });

    // 次へボタンでEnterしたら次のページへ
    this.$('.next-btn,.submit-btn').on('keydown', evt => {
      const element = evt.currentTarget;

      if (evt.which === 13) {
        jquery(element).click();
      }
    });
  }
}
